/**
 * sentry 이외의 에러 체크용도로 사용
 * @param {Error} error - 에러 객체
 * @param {string} componentStack - React 컴포넌트 스택
 * @param {string} eventId - Sentry 이벤트 ID
 */
export const logService = (error: Error, componentStack: string, eventId: string): void => {
  if (!error) return;

  const errorData = {
    message: error.toString(),
    stack: error.stack,
    componentStack,
    sentryEventId: eventId, // Sentry 에러와 연결하기 위한 ID
    timestamp: new Date().toISOString(),
  };

  console.error("Error caught:", errorData);
};
